import { render } from "./ExpenseModalSectionGeneral.vue?vue&type=template&id=2d5527a2"
import script from "./ExpenseModalSectionGeneral.vue?vue&type=script&lang=js"
export * from "./ExpenseModalSectionGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__